import React from "react";
import {DeviceTechnicalTelemetryOverviewItemContainer} from "./DeviceTechnicalTelemetryOverviewItemContainer.js";
import {DeviceTechnicalTelemetryOverviewItem} from "./DeviceTechnicalTelemetryOverviewItem.js";
import {awareTelemNames, awareTelemSpec} from "./awareTelemSpec.js";
import {useTranslation} from "react-i18next";

/** Renders technical telemetry overview component
 * @param device Device to use telemetry from
 * @returns {JSX.Element}
 * @constructor
 */
export function AwareDeviceTechnicalTelemetryExtraOverview({device}) {
    const {t} = useTranslation(['technicalpage', 'common']);
        
    return <div className="device-parameters-contentbox d-xs-block p-2">
            <DeviceTechnicalTelemetryOverviewItemContainer title={t('technicalpage:overview.title.controller')}>
                <DeviceTechnicalTelemetryOverviewItem
                    item={{type: 'manual', id: '', unit: '', name_orig: 'Firmware Version'}}
                    value={device.device_twin.reported.applicationVersion === null ? "N/A" : device.device_twin.reported.applicationVersion}
                    showId={false}/>
                <DeviceTechnicalTelemetryOverviewItem
                    item={{type: 'manual', id: '', unit: '', name_orig: 'Ethernet MAC'}}
                    value={device.device_twin.reported.macAdr === null ? "N/A" : device.device_twin.reported.macAdr}
                    showId={false}/>
                <DeviceTechnicalTelemetryOverviewItem
                    item={{type: 'manual', id: '', unit: '', name_orig: 'Ethernet Ip'}}
                    value={device.device_twin.reported.ipAdr === null ? "N/A" : device.device_twin.reported.ipAdr}
                    showId={false}/>
                <DeviceTechnicalTelemetryOverviewItem item={{type: 'manual', id: '', unit: '', name_orig: 'Wlan MAC'}}
                                                      value={device.device_twin.reported.wlanMacAdr === null ? "N/A" : device.device_twin.reported.wlanMacAdr}
                                                      showId={false}/>
                <DeviceTechnicalTelemetryOverviewItem item={{type: 'manual', id: '', unit: '', name_orig: 'Wlan Ip'}}
                                                      value={device.device_twin.reported.wlanIpAdr === null ? "N/A" : device.device_twin.reported.wlanIpAdr}
                                                      showId={false}/>
                <DeviceTechnicalTelemetryOverviewItem item={awareTelemSpec[awareTelemNames.boot_count]}
                                                      value={device.latest_telemetry?.[awareTelemNames?.boot_count] ?? 'N/A'}
                                                      deviceConnected={device.connected}
                                                      showId={false}/>
                <DeviceTechnicalTelemetryOverviewItem item={{type: 'manual', id: '', unit: '', name_orig: 'Last boot cause'}}
                                        valueOverride={device.connected ? t('telemetry:AwareBootCause_' + (device.latest_telemetry?.[awareTelemNames?.boot_cause] ?? 'unknown')) : '-'}
                                        deviceConnected={device.connected}
                                        showId={false}/>
            </DeviceTechnicalTelemetryOverviewItemContainer>
    </div>
}



